import { Box, styled } from "@mui/system";

export const AddItemContainer = styled(Box)({
  position: 'relative',
  marginLeft: 'auto',
});

export const AddItemOptionsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '11px',
  fontWeight: 400,
  color: '#000',
  boxShadow: '0px 1px 4px 0px #00000040',
  padding: '11px 0',
  minWidth: '140px',
  position: 'absolute',
  background: '#fff',
  zIndex: 5,
  marginTop: '2px',
});

export const AddItemOption = styled(Box)({
  cursor: 'pointer',
  padding: '5px 16px',
  '&:hover': {
    background: '#EFF5F8'
  },
});
